"use client";
import React from "react";
import Link from "@/components/Link";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import { Button } from "@dxp-feed/ui/Button";
import AdSlot from "@/helpers/gpt";
import { adsScript } from "@/utils/adsTempConstant";
import ImageWrapper from "@/components/ImageWrapper";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";

interface MoreFromSobeys {
  columnControl: any;
}
export default function MoreItems({ columnControl }: MoreFromSobeys) {
  const path = useAppSelector((state) => state?.adsSclice?.page ?? "");

  return (
    <Box
      as="div"
      className="more-from-sobeys-section bg-brandWhite pb-[0px] lg:pb-[0px]"
    >
      <Box
        as="div"
        className="grid md:grid-cols-2 lg:grid-cols-3 gap-[12px] md:gap-[0] lg:gap-[24px] lg:pt-[0px]"
      >
        <Box
          as="div"
          className="col-span-1 bg-brandWhite rounded-xl shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] md:mr-[12px] lg:mr-[0] flex flex-col justify-start items-stretch"
        >
          <Box as="div" className="imageouter">
            <ImageWrapper
              src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-1"]?.[":items"]?.bscards?.image}`}
              width={464}
              height={218}
              className="mx-auto w-full md:h-auto rounded-t-xl h-[135px] object-cover"
              alt="Transaction Gif"
            />
          </Box>
          <Box
            as="div"
            className="contentouter p-[16px] lg:p-[24px] flex flex-col justify-between items-start h-full"
          >
            <Box as="div" className="card_content">
              <Text
                as="h3"
                className="text-brandBlack text-[20px] font-extrabold leading-normal mb-[4px] md:mb-[8px] lg:mb-[16px] common-sec-title font-sans"
              >
                {columnControl?.["column-1"]?.[":items"]?.bscards?.heading}
              </Text>
              <Text
                as="p"
                className="text-brandBlack text-body font-normal leading-normal mb-[16px] md:mb-[8px] lg:mb-[16px]"
              >
                {columnControl?.["column-1"]?.[":items"]?.bscards?.description
                  ? new DOMParser().parseFromString(
                      columnControl?.["column-1"]?.[":items"]?.bscards
                        ?.description,
                      "text/html"
                    )?.body?.textContent
                  : ""}
              </Text>
            </Box>
            <Button variant="primary" asChild>
              {columnControl?.["column-1"]?.[":items"]?.bscards?.ctaList[0] && (
                <Link
                  className="font-normal border-[1px] !text-body  px-[24px]"
                  href={
                    columnControl?.["column-1"]?.[":items"]?.bscards?.ctaList[0]
                      ?.link || "#"
                  }
                  target={
                    columnControl?.["column-1"]?.[":items"]?.bscards?.ctaList[0]
                      ?.target
                  }
                  aria-label={
                    columnControl?.["column-1"]?.[":items"]?.bscards?.ctaList[0]
                      ?.ariaLabel
                  }
                >
                  {
                    columnControl?.["column-1"]?.[":items"]?.bscards?.ctaList[0]
                      ?.linkTitle
                  }
                </Link>
              )}
            </Button>
          </Box>
        </Box>
        <Box
          as="div"
          className="col-span-1 bg-brandWhite rounded-xl shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] md:ml-[12px] lg:ml-[0] flex flex-col justify-start items-stretch"
        >
          <Box as="div" className="imageouter">
            <ImageWrapper
              src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-2"]?.[":items"]?.bscards_1665747952?.image}`}
              width={464}
              height={218}
              className="mx-auto w-full md:h-auto rounded-t-xl h-[135px] object-cover"
              alt="Transaction Gif"
            />
          </Box>
          <Box
            as="div"
            className="contentouter p-[16px] lg:p-[24px] flex flex-col justify-between items-start h-full"
          >
            <Box as="div" className="card_content">
              <Text
                as="h3"
                className="text-brandBlack text-xl font-extrabold leading-normal mb-[4px] md:mb-[8px] lg:mb-[16px] common-sec-title font-sans"
              >
                {
                  columnControl?.["column-2"]?.[":items"]?.bscards_1665747952
                    ?.heading
                }
              </Text>
              <Text
                as="p"
                className="text-brandBlack text-body font-normal leading-normal mb-[16px] md:mb-[8px] lg:mb-[16px]"
              >
                {columnControl?.["column-2"]?.[":items"]?.bscards_1665747952
                  ?.description
                  ? new DOMParser().parseFromString(
                      columnControl?.["column-2"]?.[":items"]
                        ?.bscards_1665747952?.description,
                      "text/html"
                    )?.body?.textContent
                  : ""}
              </Text>
            </Box>
            <Button variant="primary" asChild>
              {columnControl?.["column-2"]?.[":items"]?.bscards_1665747952
                ?.ctaList[0]?.link && (
                <Link
                  className="font-normal border-[1px] !text-body  px-[24px]"
                  href={
                    columnControl?.["column-2"]?.[":items"]?.bscards_1665747952
                      ?.ctaList[0]?.link || "#"
                  }
                  target={
                    columnControl?.["column-2"]?.[":items"]?.bscards_1665747952
                      ?.ctaList[0].target
                  }
                  aria-label={
                    columnControl?.["column-2"]?.[":items"]?.bscards_1665747952
                      ?.ctaList[0].ariaLabel
                  }
                >
                  {
                    columnControl?.["column-2"]?.[":items"]?.bscards_1665747952
                      ?.ctaList[0]?.linkTitle
                  }
                </Link>
              )}
            </Button>
          </Box>
        </Box>
        <AdSlot
          id={adsScript?.[path]?.homeSobeysApp?.id}
          height="100%"
          className="hidden xl:flex [&>div>iframe]:!rounded-lg items-center justify-center h-full min-h-full [&>div]:!h-[100%] [&>div]:!flex  [&>div]:!items-center [&>div]:!justify-center "
          Fallback={
            <Box
              as="div"
              className="hidden xl:flex col-span-1 relative bg-primary200 rounded-xl md:col-span-3 lg:col-span-1 md:mt-[24px] lg:mt-[0]"
            >
              <Box
                as="div"
                className="contentouter p-[16px] pb-[118px] mb:px-[24px] md:pb-[32px] lg:p-[32px] lg:pe-[72px] 2xl:hidden block"
              >
                <Link href="/">
                  <Text
                    as="h3"
                    className="text-brandBlack text-2xl font-extrabold leading-normal mb-[8px] lg:mb-[16px] common-sec-title"
                  >
                    {columnControl?.["column-3"]?.[":items"]?.applinks?.heading}
                  </Text>

                  <Text
                    as="p"
                    className="text-brandBlack text-body font-normal leading-normal mb-[16px] md:mb-[8px] lg:mb-[24px] max-w-[330px]"
                  >
                    {
                      columnControl?.["column-3"]?.[":items"]?.applinks
                        ?.description
                    }
                  </Text>
                </Link>
                <Link
                  href={
                    columnControl?.["column-3"]?.[":items"]?.applinks
                      ?.appstorelink || "#"
                  }
                  target="_blank"
                  className=""
                >
                  <ImageWrapper
                    src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.appstoreimage}`}
                    width={107}
                    height={34}
                    className=" mb-2"
                    alt={
                      columnControl?.["column-3"]?.[":items"]?.applinks
                        ?.appstoreimagealt
                    }
                  />
                </Link>
                <Link
                  href={
                    columnControl?.["column-3"]?.[":items"]?.applinks
                      ?.playstorelink || "#"
                  }
                  target="_blank"
                  className=""
                >
                  <ImageWrapper
                    src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.playstoreimage}`}
                    width={107}
                    height={34}
                    className=" mb-2"
                    alt={
                      columnControl?.["column-3"]?.[":items"]?.applinks
                        ?.playstoreimagealt
                    }
                  />
                </Link>
                <Link
                  href="/"
                  className="mobile-screen-image absolute bottom-0 right-[10px] 3xs:right-[20px]"
                >
                  <ImageWrapper
                    src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.logoimage}`}
                    width="215"
                    height="270"
                    className="w-[160px] lg:w-[140px] xl:w-[200px] 2xl:w-[215px]"
                    alt={
                      columnControl?.["column-3"]?.[":items"]?.applinks
                        ?.logoimagealt
                    }
                  />
                </Link>
              </Box>

              <Box
                as="div"
                className="contentouter p-[16px] pb-[118px] mb:px-[24px] md:pb-[32px] lg:p-[32px] lg:pe-[72px] hidden 2xl:flex 2xl:flex-col"
              >
                <Link href="/">
                  <Text
                    as="h3"
                    className="text-brandBlack text-2xl font-extrabold leading-normal mb-[8px] lg:mb-[16px] common-sec-title font-sans"
                  >
                    {columnControl?.["column-3"]?.[":items"]?.applinks?.heading}
                  </Text>

                  <Text
                    as="p"
                    className="text-brandBlack text-body font-normal leading-normal mb-[16px] md:mb-[8px] lg:mb-[24px] max-w-[330px]"
                  >
                    {
                      columnControl?.["column-3"]?.[":items"]?.applinks
                        ?.description
                    }
                  </Text>
                </Link>
                <Link
                  href={
                    columnControl?.["column-3"]?.[":items"]?.applinks
                      ?.appstorelink || "#"
                  }
                  target="_blank"
                  className=""
                >
                  <ImageWrapper
                    src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.appstoreimage}`}
                    width={107}
                    height={34}
                    className=" mb-2"
                    alt={
                      columnControl?.["column-3"]?.[":items"]?.applinks
                        ?.appstoreimagealt
                    }
                  />
                </Link>
                <Link
                  href={
                    columnControl?.["column-3"]?.[":items"]?.applinks
                      ?.playstorelink || "#"
                  }
                  target="_blank"
                  className=""
                >
                  <ImageWrapper
                    src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.playstoreimage}`}
                    width={107}
                    height={34}
                    className=" mb-2"
                    alt={
                      columnControl?.["column-3"]?.[":items"]?.applinks
                        ?.playstoreimagealt
                    }
                  />
                </Link>
                <Link
                  href="/"
                  className="mobile-screen-image absolute bottom-0 right-[10px] 3xs:right-[20px]"
                >
                  <ImageWrapper
                    src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.logoimage}`}
                    width="215"
                    height="270"
                    className="w-[160px] lg:w-[140px] xl:w-[200px] 2xl:w-[215px]"
                    alt={
                      columnControl?.["column-3"]?.[":items"]?.applinks
                        ?.logoimagealt
                    }
                  />
                </Link>
              </Box>
            </Box>
          }
        />

        {/* Mobile and Tablet */}
        <Box
          as="div"
          className="flex xl:hidden col-span-1 relative bg-primary200 rounded-xl md:col-span-3 lg:col-span-1 md:mt-[24px] lg:mt-[0]"
        >
          <Box
            as="div"
            className="contentouter p-[16px] pb-[118px] mb:px-[24px] md:pb-[32px] lg:p-[32px] lg:pe-[72px] 2xl:hidden block"
          >
            <Link href="/">
              <Text
                as="h3"
                className="text-brandBlack text-2xl font-extrabold leading-normal mb-[8px] lg:mb-[16px] common-sec-title"
              >
                {columnControl?.["column-3"]?.[":items"]?.applinks?.heading}
              </Text>

              <Text
                as="p"
                className="text-brandBlack text-body font-normal leading-normal mb-[16px] md:mb-[8px] lg:mb-[24px] max-w-[330px]"
              >
                {columnControl?.["column-3"]?.[":items"]?.applinks?.description}
              </Text>
            </Link>
            <Link
              href={
                columnControl?.["column-3"]?.[":items"]?.applinks
                  ?.appstorelink || "#"
              }
              target="_blank"
              className=""
            >
              <ImageWrapper
                src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.appstoreimage}`}
                width={107}
                height={34}
                className=" mb-2"
                alt={
                  columnControl?.["column-3"]?.[":items"]?.applinks
                    ?.appstoreimagealt
                }
              />
            </Link>
            <Link
              href={
                columnControl?.["column-3"]?.[":items"]?.applinks
                  ?.playstorelink || "#"
              }
              target="_blank"
              className=""
            >
              <ImageWrapper
                src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.playstoreimage}`}
                width={107}
                height={34}
                className=" mb-2"
                alt={
                  columnControl?.["column-3"]?.[":items"]?.applinks
                    ?.playstoreimagealt
                }
              />
            </Link>
            <Link
              href="/"
              className="mobile-screen-image absolute bottom-0 right-[10px] 3xs:right-[20px]"
            >
              <ImageWrapper
                src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.logoimage}`}
                width="215"
                height="270"
                className="w-[160px] lg:w-[140px] xl:w-[200px] 2xl:w-[215px]"
                alt={
                  columnControl?.["column-3"]?.[":items"]?.applinks
                    ?.logoimagealt
                }
              />
            </Link>
          </Box>

          <Box
            as="div"
            className="contentouter p-[16px] pb-[118px] mb:px-[24px] md:pb-[32px] lg:p-[32px] lg:pe-[72px] hidden 2xl:flex 2xl:flex-col"
          >
            <Link href="/">
              <Text
                as="h3"
                className="text-brandBlack text-2xl font-extrabold leading-normal mb-[8px] lg:mb-[16px] common-sec-title font-sans"
              >
                {columnControl?.["column-3"]?.[":items"]?.applinks?.heading}
              </Text>

              <Text
                as="p"
                className="text-brandBlack text-body font-normal leading-normal mb-[16px] md:mb-[8px] lg:mb-[24px] max-w-[330px]"
              >
                {columnControl?.["column-3"]?.[":items"]?.applinks?.description}
              </Text>
            </Link>
            <Link
              href={
                columnControl?.["column-3"]?.[":items"]?.applinks
                  ?.appstorelink || "#"
              }
              target="_blank"
              className=""
            >
              <ImageWrapper
                src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.appstoreimage}`}
                width={107}
                height={34}
                className=" mb-2 lg:h-[34px]"
                alt={
                  columnControl?.["column-3"]?.[":items"]?.applinks
                    ?.appstoreimagealt
                }
              />
            </Link>
            <Link
              href={
                columnControl?.["column-3"]?.[":items"]?.applinks
                  ?.playstorelink || "#"
              }
              target="_blank"
              className=""
            >
              <ImageWrapper
                src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.playstoreimage}`}
                width={107}
                height={34}
                className=" mb-2 lg:h-[34px]"
                alt={
                  columnControl?.["column-3"]?.[":items"]?.applinks
                    ?.playstoreimagealt
                }
              />
            </Link>
            <Link
              href="/"
              className="mobile-screen-image absolute bottom-0 right-[10px] 3xs:right-[20px]"
            >
              <ImageWrapper
                src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-3"]?.[":items"]?.applinks?.logoimage}`}
                width="215"
                height="270"
                className="w-[160px] lg:w-[140px] xl:w-[200px] 2xl:w-[215px]"
                alt={
                  columnControl?.["column-3"]?.[":items"]?.applinks
                    ?.logoimagealt
                }
              />
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
